'use client';

/**
 * For someone signed in: straight back into the project they were last
 * working on, by name, under the hero's one action. Resolved on the client so
 * the page itself stays static; it rises in when the answer arrives, under
 * the button, so nothing the visitor may already be reaching for moves.
 */

import Link from 'next/link';
import { ArrowRight } from 'lucide-react';
import { buttonClass } from '@/components/ui/Button';
import { useSavedRooms } from '@/lib/session/savedRooms';
import { useSessionSummary } from '@/lib/session/sessionSummary';
import { HOME_HERO } from '@/lib/copy/homepage';

export default function ContinueLink() {
  const { signedIn } = useSessionSummary();
  // Newest first: the one they were last working on.
  const last = useSavedRooms(signedIn)?.[0];
  if (!last) return null;
  return (
    <Link
      href={`/room/${last.token}`}
      className={buttonClass({ variant: 'ghost', size: 'sm', className: 'rt-rise-in group max-w-full !text-body' })}
      data-testid="home-continue"
    >
      <span className="truncate">
        {HOME_HERO.continue} <span className="font-semibold">{last.title}</span>
      </span>
      <ArrowRight
        className="h-4 w-4 shrink-0 transition-transform duration-[var(--rt-spring-ms)] ease-[var(--rt-ease-spring)] group-hover:translate-x-0.5"
        aria-hidden
      />
    </Link>
  );
}
